/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StationsStationsGroupsListQueryResponse } from "../models/StationsStationsGroupsList";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { stationsStationsGroupsList } from "../axios/stationsStationsGroupsList";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const stationsStationsGroupsListQueryKey = () => ["api-v2", { url: '/station-groups/v1' }] as const

export type StationsStationsGroupsListQueryKey = ReturnType<typeof stationsStationsGroupsListQueryKey>

export function stationsStationsGroupsListQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = stationsStationsGroupsListQueryKey()
        return queryOptions<StationsStationsGroupsListQueryResponse, ResponseErrorConfig<Error>, StationsStationsGroupsListQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return stationsStationsGroupsList({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns all stations groups for the authenticated client, including their stations.
 * @summary List stations groups
 * {@link /station-groups/v1}
 */
export function useStationsStationsGroupsList<TData = StationsStationsGroupsListQueryResponse, TQueryData = StationsStationsGroupsListQueryResponse, TQueryKey extends QueryKey = StationsStationsGroupsListQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<StationsStationsGroupsListQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? stationsStationsGroupsListQueryKey()
         

         const query = useQuery({
          ...stationsStationsGroupsListQueryOptions(config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}